// What a surface should offer for an attention card.
export function isPlayableVideoKind(kind) {
    return kind === "reset" || kind === "guide";
}
// The one source of an attention card's primary-action label, shared by web
// and mobile so a kind reads the same wherever the card is rendered. Every
// known kind is enumerated; unknown or future kinds fall through to the safe
// hand-over ("Open") rather than inheriting an action a surface may not be
// able to perform.
export function primaryActionLabel(kind) {
    switch (kind) {
        case "reset":
            return "Play reset";
        case "guide":
            return "Play guide";
        case "story":
            return "Read article";
        case "recipe":
            return "Open recipe";
        case "capture":
            return "Log it";
        case "brief":
            return "Listen";
        case "reinforcement":
        case "quiet_check":
            return "Mark as done";
        case "tour":
        case "moment":
            return "Open";
        case "comprehension":
            return "Yes";
        default:
            return "Open";
    }
}
// Whether the card can be finished where it is shown. Everything else needs an
// experience the surface may not have (a reset player, an article reader), so a
// surface without it hands over rather than claiming completion. Unknown kinds
// are handed over on purpose: a kind added later must not inherit a completion
// button that does the wrong thing.
export function completesInPlace(action) {
    return action?.kind === "reinforcement" || action?.kind === "quiet_check";
}
//# sourceMappingURL=attention-action.js.map